import Vue from 'vue';
import ttIcon from './tt-icon.vue';
import postcode from './postcode.vue';

Vue.component(ttIcon.name, ttIcon);
Vue.component(postcode.name, postcode);
